import React, { useEffect, useState } from 'react'

import { Icon, message, Modal, Spin } from 'antd'

import './styles.scss'
import AiMazeGeneration from '../AiMazeGeneration'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { api } from '../../../../../../services'

const ChoiceModal = props => {
  const [isAiModalVisible, setIsAiModalVisible] = useState(false)

  const { t } = useTranslation()

  const mazeById = useSelector(state => state.maze.mazeById)

  const { onClose } = props
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (mazeById && mazeById.generated_status) {
      setIsAiModalVisible(true)
    }
  }, [mazeById])

  if (isAiModalVisible) {
    return (
      <AiMazeGeneration
        status={mazeById && mazeById.generated_status}
        {...props}
      />
    )
  }
  const checkAiCreditStatus = async () => {
    setLoading(true)
    try {
      const response = await api.aiCredits.checkAiCreditsStatus("maze")
      if (response?.data?.allowed) {
        setIsAiModalVisible(true)
      } else {
        message.error(t('aiusage:you_do_not_have_enough_ai_credits') + " maze")
      }
    } catch (error) {
      message.error(t('aiusage:error_fetching_ai_credit_status'))
    }
    setLoading(false)
  }
  return (
    <Modal visible footer={false} centered={true} closable={false} width={800}>
      <div className="choice-modal">
        <p> {t('v4:what_kind_maze_create')}</p>

        <div className="choice-modal__items">
          <div className="choice-modal__item" onClick={onClose}>
            <Icon type="user" />
            <h3>{t('v4:manual_metamaze_creation')}</h3>

            <p>{t('v4:manually_maze_customizing_scnario')}</p>
          </div>
          <Spin spinning={loading}>
            <div
              className="choice-modal__item"
              onClick={() => checkAiCreditStatus()}
            >
              <Icon type="robot" />
              <h3>{t('v4:ai_metamaze_generate')}</h3>

              <p>{t('v4:maze_ai_generated')}</p>
            </div>
          </Spin>

        </div>
      </div>
    </Modal>
  )
}

export default ChoiceModal
